module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    attrs: {
      "height": "auto",
      "dark": ""
    }
  }, [_c('div', {
    staticClass: "footer-container teal darken-2"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Siberian-Larch-1109601115809052/",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/siberianlarch_nz",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "links-section"
  }, [_c('div', {
    staticClass: "link-item"
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "color": "white",
      "flat": "",
      "to": "/privacy",
      "ripple": false
    }
  }, [_vm._v("\n          Privacy Policy\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "link-item"
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "color": "white",
      "flat": "",
      "to": "/terms",
      "ripple": false
    }
  }, [_vm._v("\n          Terms of service\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "link-item"
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "color": "white",
      "flat": "",
      "to": "/contact",
      "ripple": false
    }
  }, [_vm._v("\n          Contact Us\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body-1",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_vm._v("\n      Copyright ©2018 — "), _c('strong', [_vm._v("siberianlarchwood.co.nz")]), _vm._v(", All rights reserved.\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ee1562","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 263
// module chunks = 6